import { IGetCategoryMenuUsecase } from '@modules/header/domain/ports/getCategoryMenu.usecase.port';
import { ICategoryMenuRepository } from '../ports/categoryMenu.repository.port';
export class GetCategoryMenuUsecase implements IGetCategoryMenuUsecase {
  constructor(private readonly categoryMenuRepository: ICategoryMenuRepository) {}
  async handle(): IGetCategoryMenuUsecase.output {
    return await this.categoryMenuRepository.getCategoryMenu();
  }
}